// TODO: i18n implementation to translate
// import { useEffect } from "react";
import { FoundationsInputType } from '../Types/FoundationsTypes'
import { FoundationsTooltip } from './tooltip'
import { FoundationsGeneric } from './FoundationsGeneric'

export function FoundationsInput(props: FoundationsInputType) {
    function handleInput(e: any) {
        props.onInput !== undefined ? props.onInput(e) : () => {}
    }
    return (
        <FoundationsGeneric
            id={props.id + '_container'}
            customStyle={props.customStyle}
            classes={props.classes}
        >
            {props.labelText?.length === 0 ? (
                <span
                    className={(props.containerClasses || '') + ' d-inline-block'}
                    style={{ verticalAlign: 'middle' }}
                >
                    <input
                        type={props.type}
                        className={'form-control on_key_press_enter ' + (props.inputClasses || '')}
                        id={props.id}
                        maxLength={props.maxLength}
                        style={{
                            border: '1px solid #767676',
                            boxSizing: 'border-box',
                            padding: '.4rem',
                            width: '100%',
                        }}
                        placeholder={props.placeHolder}
                        data-toggle="tooltip"
                        name={props.name}
                        data-hash={props.hash}
                        data-collection_index={props.collectionIndex}
                        data-original-title={props.placeHolder || ''}
                        value={props.value}
                        disabled={props.disabled ? true : false}
                        onInput={handleInput}
                        {...(props.registerFunction
                            ? props.registerFunction(props.registerName, props.registerRules)
                            : {})}
                    />
                </span>
            ) : (
                <>
                    <span
                        className={(props.labelClasses || '') + ' col-form-label'}
                        style={{ paddingRight: '0px', verticalAlign: 'middle' }}
                    >
                        {props.labelText}
                        {props.optional && <small className="text-muted">(optional)</small>}
                        {props.isAsterisk && <span style={{ color: 'red' }}>&#42;</span>}
                    </span>
                    <span
                        className={(props.containerClasses || '') + ' d-inline-block'}
                        style={{ verticalAlign: 'middle' }}
                    >
                        <input
                            type={props.type}
                            className={
                                'on_key_press_enter foundations_input ' + (props.inputClasses || '')
                            }
                            id={props.id}
                            maxLength={props.maxLength}
                            style={{
                                border: '1px solid #767676',
                                boxSizing: 'border-box',
                                padding: '.4rem',
                                width: '100%',
                            }}
                            placeholder={props.placeHolder}
                            data-toggle="tooltip"
                            name={props.name}
                            data-collection_index={props.collectionIndex}
                            data-original-title={props.placeHolder || ''}
                            value={props.value}
                            disabled={props.disabled ? true : false}
                            onInput={handleInput}
                            autoComplete={props.autocomplete}
                            {...(props.registerFunction
                                ? props.registerFunction(props.registerName, props.registerRules)
                                : {})}
                            //aria-autocomplete={props.ariaAutocomplete} - > TODO
                        />
                        {props.error && (
                            <span style={{ height: '17px' }}>
                                <label
                                    htmlFor={props.id}
                                    className="error field-validation-error d-block"
                                >
                                    {'' + props.error}
                                </label>
                            </span>
                        )}
                    </span>
                </>
            )}
            {props.toolTipText !== undefined ? (
                <span
                    className={'text-right mt-1 tooltip-icons ' + props.tooltipClasses}
                    style={{ verticalAlign: 'middle' }}
                >
                    <FoundationsTooltip
                        id={'tooltip_icon_' + props.id}
                        text={props.toolTipText}
                        style={{
                            transform: 'translate(30%, 10%)',
                            fontWeight: 'bold',
                        }}
                    />
                </span>
            ) : (
                <></>
            )}
        </FoundationsGeneric>
    )
}
